import { useCallback, useState } from "react";
import eligibilityCheckServices from "../../../../services/api/service/eligibilityCheckService";
import { setStatusPopup } from "../../../../services/redux/slices/statusPopupSlice";

export function usePanOtp({
  dispatch,
  coApplicantFormData,
}: {
  dispatch: any;
  coApplicantFormData: any;
}) {
  const [isPanOtpModalOpen, setIsPanOtpModalOpen] = useState(false);
  const [panOtpData, setPanOtpData] = useState({
    panNumber: "",
    otpKey: "",
    otpTime: "",
    firstName: "",
  });
  const [isPanVerified, setIsPanVerified] = useState(false);

  const handleClosePanOtpModal = useCallback(() => {
    setIsPanOtpModalOpen(false);
    setPanOtpData({ panNumber: "", otpKey: "", otpTime: "", firstName: "" });
  }, []);

  const handlePanOtpSubmit = useCallback(
    async (otp: string) => {
      try {
        const firstFieldName = Object.keys(coApplicantFormData).find((key) =>
          key.includes("basicCoApplicant")
        );
        const coApplicantNumberFromKey = firstFieldName
          ? firstFieldName.match(/basicCoApplicant(\d+)/)?.[1]
          : "1";

        const verifyResp = await eligibilityCheckServices.verifyOtp({
          type: "mobile",
          mobileNumber:
            coApplicantFormData?.[
              `basicCoApplicant${coApplicantNumberFromKey}PhoneNumber`
            ] || "",
          key: panOtpData.otpKey,
          mobileOtp: otp,
          mobileOtpCrtdAt: panOtpData.otpTime,
        });

        if (verifyResp?.status === 200) {
          setIsPanVerified(true);
          handleClosePanOtpModal();
          dispatch(
            setStatusPopup({
              status: "success",
              message: "OTP verified successfully!",
            })
          );
        } else {
          dispatch(
            setStatusPopup({
              status: "error",
              message: "Invalid OTP. Please try again.",
            })
          );
        }
      } catch (error: any) {
        dispatch(
          setStatusPopup({
            status: "error",
            message: error?.response?.data?.message || "OTP verification failed.",
          })
        );
      }
    },
    [coApplicantFormData, dispatch, handleClosePanOtpModal, panOtpData.otpKey, panOtpData.otpTime]
  );

  const handleResendPanOtp = useCallback(async () => {
    try {
      const response = await eligibilityCheckServices.sendOtp({
        name: panOtpData.firstName,
        mobileNumber: coApplicantFormData.mobileNumber,
      });

      if (response?.data?.status === "success") {
        setPanOtpData((prev) => ({
          ...prev,
          otpKey: response.data.data.value,
          otpTime: response.data.data.otpTime,
        }));
        dispatch(
          setStatusPopup({
            status: "success",
            message: "OTP resent successfully!",
          })
        );
      } else {
        dispatch(
          setStatusPopup({
            status: "error",
            message: "Failed to resend OTP. Please try again.",
          })
        );
      }
    } catch {
      dispatch(
        setStatusPopup({
          status: "error",
          message: "Error resending OTP. Please try again.",
        })
      );
    }
  }, [coApplicantFormData.mobileNumber, dispatch, panOtpData.firstName]);

  return {
    isPanOtpModalOpen,
    setIsPanOtpModalOpen,
    panOtpData,
    setPanOtpData,
    isPanVerified,
    setIsPanVerified,
    handleClosePanOtpModal,
    handlePanOtpSubmit,
    handleResendPanOtp,
  };
}

